/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import { bool, func, node } from 'prop-types';
import classNames from 'classnames';
import { Heading } from 'components/common';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './FunnelInputGroup.scss';

const FunnelInputGroup = ({
  disablePresetFont,
  isActive,
  isCurrent,
  onClick,
  children,
}) => (
  <div
    className={classNames({
      'funnel-input-group': true,
      active: isActive,
      current: isCurrent,
    })}
    onClick={onClick}
  >
    {/* Appear animation */}
    <ReactCSSTransitionGroup
      transitionName="fade-in"
      transitionAppear
      transitionAppearTimeout={300}
      transitionEnterTimeout={500}
      transitionLeaveTimeout={300}
    >
      {disablePresetFont
        ? children
        : (
          <Heading as={isCurrent ? 'h2' : 'h3'}>
            {children}
          </Heading>
        )}
    </ReactCSSTransitionGroup>
  </div>
);

FunnelInputGroup.propTypes = {
  disablePresetFont: bool,
  isActive: bool,
  isCurrent: bool,
  onClick: func,
  children: node,
};

FunnelInputGroup.defaultProps = {
  disablePresetFont: false,
  isActive: false,
  isCurrent: false,
  onClick: undefined,
  children: null,
};

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      isVisible: false,
    };
  }

  componentDidMount() {
    // Display header after 1 seconds
    setTimeout(() => {
      this.setState({ isVisible: true });
    }, 1000);
  }

  render() {
    const { isVisible } = this.state;
    const { children } = this.props;
    return (
      <div>
        {isVisible && (
          // Appear animation
          <ReactCSSTransitionGroup
            transitionName="fade-in"
            transitionAppear
            transitionAppearTimeout={300}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            <div className="funnel-input-group-header">
              {children}
            </div>
          </ReactCSSTransitionGroup>
        )}
      </div>
    );
  }
}

Header.propTypes = {
  children: node,
};

Header.defaultProps = {
  children: null,
};

FunnelInputGroup.Header = Header;

export default FunnelInputGroup;
